import '@fontsource/vazirmatn/400.css';
import '@fontsource/vazirmatn/500.css';
import '@fontsource/vazirmatn/600.css';
import '@fontsource/vazirmatn/700.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/global.scss';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// service worker فقط روی سایتِ واقعی ثبت می‌شود، نه روی localhost: اگر یک build نهایی روی localhost تست
// شود و sw.js ثبت شود، همان service worker در مرورگر می‌ماند و بعداً در `npm start` صفحه‌ی قدیمیِ کش‌شده
// را نشان می‌دهد که به یک فایلِ js قدیمی اشاره می‌کند (خطای 404 + «MIME type text/html»)
const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production' && !isLocalhost) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js');
  });
}